
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import SwiperCore from 'swiper';
SwiperCore.use([Autoplay]);

const testimonials = [
  { name: "James Dixon", message: "Fantastically professional! Will use again and would absolutely recommend!", avatar: "https://randomuser.me/api/portraits/men/75.jpg" },
  { name: "Danny Binson", message: "Our experience with WorkDesk VA was outstanding. They quickly understood complex requirements, optimized performance, and delivered advanced features with clean, scalable code. Communication was clear and proactive. Highly recommended for any AI, web, or full-stack project.", avatar: "https://randomuser.me/api/portraits/men/32.jpg" },
  { name: "Jenny Mustazza", message: "WorkDesk VA is extremely talented and delivered the project on time and on budget. I would definitely recommend WorkDesk VA for any machine learning project you need help with!", avatar: "https://randomuser.me/api/portraits/women/68.jpg" },
  { name: "Chris Allen", message: "WorkDesk VA was a pleasure to work with. They submitted a strong application and clearly explained their approach to the task from the outset. The quality of their work was excellent, and their communication throughout the project was reliable and clear.", avatar: "https://randomuser.me/api/portraits/men/65.jpg" },
  { name: "James Stinson, Full Potential", message: "Great contractor, will work with again. Thank you!", avatar: "https://randomuser.me/api/portraits/men/44.jpg" },
  { name: "Enid Crooks", message: "Thank you for your hard work.", avatar: "https://randomuser.me/api/portraits/women/44.jpg" },
  { name: "Samantha De Ceco", message: "WorkDesk VA did a fantastic job with creating an AI ML Model, highly recommended.", avatar: "https://randomuser.me/api/portraits/women/65.jpg" },
  { name: "David York", message: "WorkDesk VA did a great job, they're very easy to work with, and a true professional. 5-stars!", avatar: "https://randomuser.me/api/portraits/men/13.jpg" },
  { name: "Lauren Stevens", message: "WorkDesk VA delivered good work on this AI Chatbot development project and I enjoyed working with them. Communication was top-notch, all deadlines were met, and their skills were strong. I'll likely have more jobs for them in the future.", avatar: "https://randomuser.me/api/portraits/women/26.jpg" },
  { name: "Jack Stevens", message: "WorkDesk VA is exceptional. Their skills in Angular and NodeJS are great. They did a quick job and delivered us quality work. HIGHLY RECOMMENDED!", avatar: "https://randomuser.me/api/portraits/men/22.jpg" },
  { name: "Ahmad Mughal", message: "WorkDesk VA did an exceptional job. Their expertise in AI and NLP are excellent. They understood all requirements and delivered the work before deadline. HIGHLY RECOMMENDED!", avatar: "https://randomuser.me/api/portraits/men/67.jpg" },
];

const Testimonial = () => {
  return (
    <section className="review_section">
      <div className="container">
        <div className="heading_block">
          <h2 className="heading_text">What Our Clients Say</h2>
          <p className="heading_description">
            Hear directly from our satisfied clients about their experience working with{' '}
            <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>.
          </p>
        </div>

        <Swiper
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          speed={8000} // 👈 slow and smooth
          autoplay={{
            delay: 0, // 👈 no gap, continuous motion
            disableOnInteraction: false,
            pauseOnMouseEnter: true, // 👈 stops smoothly on hover
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          allowTouchMove={false}
          modules={[Autoplay]}
        >
          {testimonials.map((t, idx) => (
            <SwiperSlide key={idx}>
              <article className="card">
                <div className="card-inner">
                  <div className="avatar-block">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      style={{
                        width: 60,
                        height: 60,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid #E3F0FF",
                      }}
                    />
                  </div>
                  <p className="message">
                    “{
                      t.message.split(/WorkDesk VA/).reduce((acc, part, i, arr) => {
                        if (i === arr.length - 1) return acc.concat(part);
                        return acc.concat(
                          part,
                          <span key={i} className="workdeskva-brand"><span className="workdeskva-bold">Work</span><span className="workdeskva-light">Desk</span><span className="workdeskva-va">VA</span></span>
                        );
                      }, [])
                    }”
                  </p>
                  <div className="author">{t.name}</div>
                </div>
                <div className="dashed-border" aria-hidden="true" />
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style>{`
        :root {
          --teal: #1995A2;
          --card-bg: #fff;
          --page-bg: #f8f9fa;
          --card-radius: 16px;
          --card-height: 260px;
        }

        .review_section {
          background: var(--page-bg);
          padding: 64px 20px;
          font-family: system-ui, -apple-system, "Segoe UI", Roboto, Arial;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .heading_block { text-align: center; margin-bottom: 32px; }
        .heading_text { font-size: 28px; font-weight: 700; color: #222; }
        .heading_description { color: #555; margin-top: 10px; }

        .card {
          position: relative;
          height: var(--card-height);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: var(--card-radius);
        }

        .card-inner {
          width: 100%;
          height: calc(var(--card-height) - 10px);
          background: var(--card-bg);
          border-radius: calc(var(--card-radius) - 4px);
          box-shadow: 0 4px 23px rgba(174,191,210,0.13);
          padding: 26px 22px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 14px;
          z-index: 2;
        }

        .avatar-block img {
          box-shadow: 0 2px 8px rgba(174,191,210,0.13);
          margin-bottom: 10px;
        }

        .message {
          font-size: 15px;
          line-height: 1.6;
          color: #49515B;
          font-style: italic;
          max-height: calc(var(--card-height) - 110px);
        }

        .author {
          margin-top: 6px;
          font-weight: 700;
          color: var(--teal);
          font-size: 15px;
        }

        .dashed-border {
          position: absolute;
          inset: 0;
          border-radius: var(--card-radius);
          border: 2px dashed var(--teal);
          z-index: 1;
          animation: dashMove 6s linear infinite;
        }

        @keyframes dashMove {
          to { stroke-dashoffset: -100; }
        }

        @media (max-width: 420px) {
          :root { --card-height: 300px; }
        }
      `}</style>
    </section>
  );
};

export default Testimonial;
